/*
 * Custom RTE content tokens (migrated from the previous theme).
 * Converts author shortcodes inside any .rte block on render:
 *   <hrule>                        -> <hr class="rte-hrule">   (thin 1px rule)
 *   <highlight_start> ... <highlight_end> -> <div class="callout">...</div> (background panel)
 * Tokens are matched in both raw (<hrule>) and escaped (&lt;hrule&gt;) forms.
 */
(function () {
  var TOKEN_TEST = /hrule|highlight_start|highlight_end/i;

  function transform(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var blocks = scope.querySelectorAll('.rte');
    for (var i = 0; i < blocks.length; i++) {
      var el = blocks[i];
      if (el.getAttribute('data-shortcodes-done') === '1') continue;
      var html = el.innerHTML;
      if (!TOKEN_TEST.test(html)) { el.setAttribute('data-shortcodes-done', '1'); continue; }
      var out = html
        .replace(/(?:&lt;|<)\s*hrule\s*\/?\s*(?:&gt;|>)/gi, '<hr class="rte-hrule">')
        .replace(/(?:&lt;|<)\s*highlight_start\s*(?:&gt;|>)/gi, '<div class="callout">')
        .replace(/(?:&lt;|<)\s*highlight_end\s*(?:&gt;|>)/gi, '</div>');
      if (out !== html) el.innerHTML = out;
      el.setAttribute('data-shortcodes-done', '1');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { transform(document); });
  } else {
    transform(document);
  }
  // Re-run when Shopify re-renders a section (theme editor) or quick view opens.
  document.addEventListener('shopify:section:load', function (e) { transform(e.target); });
})();
